import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import {
  NavBar, WhiteSpace, Toast, Card, Flex, Badge, Accordion,
} from 'antd-mobile';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';

import { RefreshIcon } from './common';
import { getDeviceDetail } from './api';
import ChartGroup from './ChartGroup';

const uniqArray = (array) => {
  const result = [];
  const map = new Map();
  for (let i = 0; i < array.length; i += 1) {
    const item = array[i];
    if (!map.has(item.name)) {
      // map.set(item.name, true);  // xu_mod
      result.push({
        ...item,
      });
    }
  }
  return result;
};

const Measurement = ({
  data: {
    title,
    value,
    vh,
    vw,
  }, // 在最后一个解构属性后面添加尾随逗号
}) => {
  const isZero = value === 0.01;
  let vhw = `${value}°C`;
  if (vh !== undefined && vh !== null) {
    vhw += `/ ${vh}%`;
  }
  if (vw !== undefined && vw !== null) {
    vhw += `/ ${vw}%`;
  }
  return (
    <Fragment>
      <Flex justify="between">
        <div>{ title }</div>
        <Badge
          text={vhw}
          style={{
            marginRight: '1em',
            background: isZero ? 'lightgray' : 'skyblue',
            width: '11em',
          }}
        />
      </Flex>
    </Fragment>
  );
};

Measurement.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
  }).isRequired,
};

class DeviceDetail extends Component {
  constructor(...args) {
    super(...args);
    this.navBack = this.navBack.bind(this);
    this.getDeviceDetail = this.getDeviceDetail.bind(this);
    this.state = {
      fetching: false,
      data: {},
    };
  }

  componentDidMount() {
    this.getDeviceDetail();
  }

  async getDeviceDetail() {
    const { match } = this.props;
    const { user, deviceId } = match.params;
    this.setState({ fetching: true });
    try {
      Toast.loading('Loading...', 0);
      const res = await getDeviceDetail(user, deviceId);
      Toast.hide();
      this.setState({
        data: res.data,
      });
    } catch (error) {
      Toast.hide();
      if (error.response) {
        Toast.fail(error.message, 2, null, false);
      } else {
        Toast.offline(error.message, 2, null, false);
      }
    }
    this.setState({ fetching: false });
  }

  navBack() {
    const { history } = this.props;
    if (history.length) {
      history.goBack();
    } else {
      const { match } = this.props;
      history.push(`/${match.params.user}`);
    }
  }

  render() {
    const { fetching, data } = this.state;
    const { name = '', lasttime, measurements = [] } = data;
    let displayTime = '';
    if (lasttime) {
      displayTime = dayjs(lasttime).format('YYYY-MM-DD HH:mm:ss');
    }
    const uniqMeasurements = uniqArray(measurements);
    const { match } = this.props;
    const { user, deviceId } = match.params;

    return (
      <DocumentTitle title="查看设备">
        <Fragment>
          <NavBar
            mode="dark"
            onLeftClick={this.navBack}
            icon={<FontAwesomeIcon icon={faArrowCircleLeft} fixedWidth />}
            rightContent={[
              <RefreshIcon key="refresh" loading={fetching} onClick={this.getDeviceDetail} />,
            ]}
          >
            设备数据
          </NavBar>

          <WhiteSpace size="lg" />
          <Card full>
            <Card.Header
              title={name}
              extra={displayTime}
            />
            <Card.Body>
              <Accordion accordion>
                {
                  uniqMeasurements.map(item => (
                    <Accordion.Panel
                      key={item.name}
                      header={(
                        <Measurement data={item} />
                      )}
                    >
                      <WhiteSpace />
                      <ChartGroup
                        measurement={item.name}
                        title={item.title}
                        deviceId={deviceId}
                        user={user}
                      />
                    </Accordion.Panel>
                  ))
                }
              </Accordion>
            </Card.Body>
          </Card>
        </Fragment>
      </DocumentTitle>
    );
  }
}

DeviceDetail.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      user: PropTypes.string.isRequired,
      deviceId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withRouter(DeviceDetail);
